import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Header } from "@/components/Header";
import Home from "@/pages/Home";
import WasherPage from "@/pages/WasherPage";
import AdminPage from "@/pages/AdminPage";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";

function App() {
  return (
    <div className="grain min-h-screen">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/spalator/:id" element={<WasherPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
